import { render } from "./CategoryStart.vue?vue&type=template&id=5e3f2451&scoped=true"
import script from "./CategoryStart.vue?vue&type=script&lang=js"
export * from "./CategoryStart.vue?vue&type=script&lang=js"

import "./CategoryStart.vue?vue&type=style&index=0&id=5e3f2451&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3f2451"]])

export default __exports__